const CLIENT_ID = window.location.hostname.indexOf('espn-consumption-tool-np') !== -1 ?
  '0oa7h8f1ljdtebbQN357' : '0oa7uyy2oaFLvmYLL357';
const ISSUER = 'https://login.apps.nielsen.com/oauth2/aus31vybzdtuWsic7357';
const OKTA_TESTING_DISABLEHTTPSCHECK = false;
const REDIRECT_UI = window.location.hostname.indexOf('espn-consumption-tool-np') !== -1 ?
  'https://espn-consumption-tool-np.ui.aws-ma-us-west-2.nlsn.media/implicit/callback' :
  'https://espnconsumption.nielsen.com/implicit/callback';

export default {
  oidc: {
    clientId: CLIENT_ID,
    issuer: ISSUER,
    redirectUri: REDIRECT_UI,
    scopes: ['openid', 'profile', 'email'],
    pkce: true,
    disableHttpsCheck: OKTA_TESTING_DISABLEHTTPSCHECK,
    refresh_token: {
      "rotation_type": "ROTATE",
      "leeway": "20"
    }
  }
};
